const ItemTypes = {
  EMPLOYEE: "employee",
  ENTITY: "entity"
};

export default ItemTypes;
